import { useCustomApplyProposalStageMeasurementsMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useCustomApplyProposalStageMeasurements() {
  const [mutation, { loading, error, data }] = useCustomApplyProposalStageMeasurementsMutation({
    refetchQueries: ["customGetProposal"],
  });

  const [customMutation, context] = useBitumioMutation(
    {
      mutation,
      loading,
      error,
      data,
      key: "applyProposalStageMeasurements",
    },
    {
      hideMessage: true,
    }
  );

  return [customMutation, context] as const;
}
